import { render } from "./NoticiaImagesModal.vue?vue&type=template&id=51cbc72c"
import script from "./NoticiaImagesModal.vue?vue&type=script&lang=js"
export * from "./NoticiaImagesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__